.filterGroups {
	display: inline-flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 6px 8px;
	align-items: center;
}

.filterGroupItem {
	display: contents;
}

.icon {
	vertical-align: text-bottom;
	width: 16px;
	height: 16px;
	margin-right: 2px;

	&.circle {
		border-radius: 50%;
	}
}

.filterItemWithIcon {
	display: inline-flex;
	height: 16px;
	align-items: center;
	gap: 2px;
	position: relative;
	top: 3px;
}

.exportPNGLozenge {
	display: inline-flex;
	align-items: center;
}
